// BolograhakHome.jsx
import React, { useState } from "react";
import { useNavigate, Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import BusinessProfileForm from './BusinessProfileForm'; 
import { logout } from '../../redux/actions/authActions';

const BoloGrahakHome = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [userName, setUserName] = useState(authState.user.name);
  const [selectedOption, setSelectedOption] = useState('Want');

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    dispatch(logout());
    navigate("/bolograhak");
  };

  const [complaints, setComplaints] = useState([
    { id: 1, company: "ABC Corp", complainant: "Sanjeev", product: "Product A", date: "2025-10-01", description: "Issue with product A quality" },
    { id: 2, company: "XYZ Ltd", complainant: "Rahul", product: "Service B", date: "2025-10-02", description: "Service B delayed" },
    { id: 3, company: "MNO Pvt", complainant: "Priya", product: "Product C", date: "2025-10-03", description: "Received defective Product C" },
    { id: 4, company: "DEF Inc", complainant: "Anita", product: "Service D", date: "2025-10-04", description: "Service D incomplete" },
    { id: 5, company: "GHI Co", complainant: "Vikram", product: "Product E", date: "2025-10-05", description: "Product E missing parts" },
    { id: 6, company: "JKL Ltd", complainant: "Rina", product: "Service F", date: "2025-10-06", description: "Service F poor response" },
    { id: 7, company: "PQR Corp", complainant: "Amit", product: "Product G", date: "2025-10-07", description: "Product G not as described" },
    { id: 8, company: "STU Pvt", complainant: "Neha", product: "Service H", date: "2025-10-08", description: "Service H incomplete installation" },
    { id: 9, company: "VWX Ltd", complainant: "Karan", product: "Product I", date: "2025-10-09", description: "Product I damaged" },
    { id: 10, company: "YZA Co", complainant: "Pooja", product: "Service J", date: "2025-10-10", description: "Service J slow response" },
  ]);

  const [selectedComplaint, setSelectedComplaint] = useState(null);
  const [showNewForm, setShowNewForm] = useState(false);
  const [newComplaint, setNewComplaint] = useState({ company: "", product: "", description: "" });
  const [submitMsg, setSubmitMsg] = useState("");

  const handleViewMore = (complaint) => {
    setSelectedComplaint(complaint);
    setShowNewForm(false);
  };

  const handleReply = () => {
    alert("Reply functionality goes here!");
  };

  const handleNewSubmit = () => {
    if (!newComplaint.company || !newComplaint.product || !newComplaint.description) {
      alert("Please fill all mandatory fields!");
      return;
    }
    setComplaints([{ 
      id: complaints.length + 1, 
      company: newComplaint.company, 
      complainant: "You", 
      product: newComplaint.product, 
      date: new Date().toISOString().split('T')[0],
      description: newComplaint.description
    }, ...complaints]);
    setNewComplaint({ company: "", product: "", description: "" });
    setSubmitMsg("Your Complaint Is Submitted!");
    setShowNewForm(false);
  };

  return (
    <div className="font-sans text-black bg-gradient-to-br from-white to-gray-50 min-h-screen">
      <header className="flex justify-between items-center px-4 py-4 bg-gradient-to-r from-green-800 to-green-900 shadow-lg sticky top-0 z-50">
        <div>
          <p className="text-2xl lg:text-3xl font-extrabold text-yellow-200 tracking-wide">Bolograhak</p>
          <p className="text-sm lg:text-xl">Empowering Comsumer Voice</p>
        </div>
        <nav className="hidden md:flex space-x-6 font-medium">
          <a href="#need" className="hover:text-yellow-400 transition-colors duration-300 text-yellow-200">Need</a>
          <a href="#want" className="hover:text-yellow-400 transition-colors duration-300 text-yellow-200">Want</a>
          <a href="#somethingnew" className="hover:text-yellow-400 transition-colors duration-300 text-yellow-200">Something New</a>
          <a href="#complaint" className="hover:text-yellow-400 transition-colors duration-300 text-yellow-200">Complaint</a>
          {/* <a href="#advice" className="hover:text-yellow-400 transition-colors duration-300 text-yellow-200">Advice</a> */}
          <a href="#whyus" className="hover:text-yellow-400 transition-colors duration-300 text-yellow-200">Why Us</a>
        </nav>

        {/* Desktop User Actions */}
        <div className="hidden md:flex items-center space-x-4">
          {isLoggedIn ? (
            <>
              <span className="text-white font-medium text-sm sm:text-base">Welcome, {userName}</span>
              <button
                onClick={() => navigate(`/bolograhakdashboard`)}
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center text-base sm:text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors duration-300 shadow-sm"
                title="Dashboard"
                aria-label="Dashboard"
              >
                🧭
              </button>
              <button
                onClick={handleLogout}
                className="w-8 h-8 sm:w-9 sm:h-9 flex items-center justify-center text-base sm:text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors duration-300 shadow-sm"
                title="Logout"
                aria-label="Logout"
              >
                ⏻
              </button>
            </>
          ) : (
            <>
              <button
                onClick={() => navigate("/login")}
                className="px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm border border-pink-500 text-white rounded-full hover:bg-pink-600 transition-colors duration-300 shadow-sm"
              >
                Login
              </button>
              <button
                onClick={() => navigate("/signup")}
                className="px-3 py-1.5 sm:px-4 sm:py-2 text-xs sm:text-sm bg-blue-500 text-white rounded-full hover:bg-pink-600 transition-colors duration-300 shadow-sm"
              >
                Register
              </button>
            </>
          )}
        </div>

        {/* Mobile Hamburger Menu Button */}
        <div className="md:hidden flex items-end justify-end w-8">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="text-xl w-8 lg:text-2xl text-yellow-200 focus:outline-none focus:ring-2 focus:ring-yellow-300 rounded p-1 hover:bg-yellow-200/20 transition-colors duration-300"
            aria-label="Toggle Menu"
          >
            {isMobileMenuOpen ? "×" : "☰"}
          </button>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-gray-600/95 backdrop-blur-sm px-4 py-4 space-y-2 text-center border-t border-gray-500">
          {isLoggedIn && (
            <div className="flex flex-col items-center py-2 text-center">
              <p className="text-white font-medium text-sm mb-2">Welcome, {userName}</p>
              <div className="flex space-x-3">
                <button
                  onClick={() => navigate(`/bolograhakdashboard`)}
                  className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors duration-300 shadow-sm"
                  aria-label="Dashboard"
                >
                  🧭
                </button>
                <button
                  onClick={handleLogout}
                  className="w-9 h-9 flex items-center justify-center text-lg bg-red-500 text-white rounded-full hover:bg-red-600 transition-colors duration-300 shadow-sm"
                  aria-label="Logout"
                >
                  ⏻
                </button>
              </div>
            </div>
          )} 
          <nav className="space-y-1">
            <a href="#need" className="block py-2 px-4 rounded-md hover:text-yellow-400 transition-colors duration-300 text-yellow-200 bg-blue-400/20 hover:bg-blue-400/30">Need</a>
            <a href="#want" className="block py-2 px-4 rounded-md hover:text-yellow-400 transition-colors duration-300 text-yellow-200 bg-blue-400/20 hover:bg-blue-400/30">Want</a>
            <a href="#somethingnew" className="block py-2 px-4 rounded-md hover:text-yellow-400 transition-colors duration-300 text-yellow-200 bg-blue-400/20 hover:bg-blue-400/30">Something New</a>
            <a href="#complaint" className="block py-2 px-4 rounded-md hover:text-yellow-400 transition-colors duration-300 text-yellow-200 bg-blue-400/20 hover:bg-blue-400/30">Complaint</a>
            {/* <a href="#advice" className="block py-2 px-4 rounded-md hover:text-yellow-400 transition-colors duration-300 text-yellow-200 bg-blue-400/20 hover:bg-blue-400/30">Advice</a> */}
            <a href="#whyus" className="block py-2 px-4 rounded-md hover:text-yellow-400 transition-colors duration-300 text-yellow-200 bg-blue-400/20 hover:bg-blue-400/30">Why Us</a>
            {/* <a href="#business" className="block py-2 px-4 rounded-md hover:text-yellow-400 transition-colors duration-300 text-yellow-200 bg-blue-400/20 hover:bg-blue-400/30">Partners</a> */}
          </nav>
          {!isLoggedIn && (
            <div className="flex flex-col sm:flex-row justify-center space-y-2 sm:space-y-0 sm:space-x-4 pt-4 border-t border-gray-500">
              <button 
                onClick={() => navigate("/login")}
                className="px-4 py-2 text-sm border border-pink-500 text-white rounded-full hover:bg-pink-50 transition-colors duration-300 w-full sm:w-auto"
              >
                Login
              </button>
              <button 
                onClick={() => navigate("/signup")}
                className="px-4 py-2 text-sm bg-pink-600 text-white rounded-full hover:bg-pink-700 transition-colors duration-300 w-full sm:w-auto"
              >
                Register
              </button>
            </div>
          )}
          <button 
            onClick={() => setIsMobileMenuOpen(false)}
            className="absolute top-4 right-4 text-white text-xl"
            aria-label="Close Menu"
          >
            ×
          </button>
        </div>
      )}

      {/* Hero Section */}
      {/* <section className="relative bg-cover bg-center flex items-center justify-center text-white py-12 sm:py-16 lg:py-20"
              style={{ backgroundImage: "url('/assets/banners/bolograhak.jpg')" 
      }}> */}
      <section className="relative bg-black bg-center flex items-center justify-center text-white py-12 sm:py-16 lg:py-20">
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="relative z-10 w-full max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold text-yellow-300 mb-4 leading-tight">
            Janta Bolti Hai. Janta Doondhti Hai.
          </h1>
          {/* <p className="text-sm sm:text-base md:text-lg text-gray-100 max-w-3xl mx-auto mb-8">
            Empowering every consumer to speak, search and choose smarter.
          </p> */}

          <div className="bg-white/10 backdrop-blur-md rounded-3xl p-4 sm:p-6 md:p-8 shadow-xl border border-white/20 mx-auto max-w-6xl">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 mb-4">
              <div className="flex flex-col items-start">
                <label className="text-xs sm:text-sm font-medium mb-1 text-yellow-100">Choose Type</label>
                <select
                  className="p-2 sm:p-3 border border-white/30 rounded-lg h-10 sm:h-12 text-black bg-white/80 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                  value={selectedOption}
                  onChange={(e) => setSelectedOption(e.target.value)}
                >
                  <option value="Want">Want</option>
                  <option value="Need">Need</option>
                  <option value="Exploring">Exploring</option>
                </select>
              </div>

              <div className="flex flex-col items-start">
                <label className="text-xs sm:text-sm font-medium mb-1 text-yellow-100">What You {selectedOption}?</label>
                <input
                  type="text"
                  placeholder="Product / Service Name"
                  className="p-2 sm:p-3 border border-white/30 rounded-lg text-black bg-white/80 focus:outline-none focus:ring-2 focus:ring-yellow-300 w-full"
                />
              </div>

              <div className="flex flex-col items-start">
                <label className="text-xs sm:text-sm font-medium mb-1 text-yellow-100">Where You {selectedOption}?</label>
                <input
                  type="text"
                  placeholder="Locality / PIN Code"
                  className="p-2 sm:p-3 border border-white/30 rounded-lg text-black bg-white/80 focus:outline-none focus:ring-2 focus:ring-yellow-300 w-full"
                />
              </div>

              <div className="flex flex-col items-start">
                <label className="text-xs sm:text-sm font-medium mb-1 text-yellow-100">When You {selectedOption}?</label>
                <select className="p-2 sm:p-3 border border-white/30 rounded-lg text-black bg-white/80 focus:outline-none focus:ring-2 focus:ring-yellow-300 h-10 sm:h-12 w-full">
                  <option>Now</option>
                  <option>Today</option>
                  <option>Tomorrow</option>
                  <option>Within A Week</option>
                  <option>Within A Month</option>
                  <option>Not Specified</option>
                  <option>Any Time</option>
                </select>
              </div>

              <div className="flex flex-col items-start">
                <label className="text-xs sm:text-sm font-medium mb-1 text-yellow-100">Your Budget?</label>
                <input
                  type="text"
                  placeholder="Enter your budget"
                  className="p-2 sm:p-3 border border-white/30 rounded-lg text-black bg-white/80 focus:outline-none focus:ring-2 focus:ring-yellow-300 w-full"
                />
              </div>
            </div>

            <div className="flex flex-row sm:flex-row items-start sm:items-center gap-2 mb-2">
              <input
                type="checkbox"
                id="allowContact"
                className="mt-1 h-4 w-4 text-yellow-300 focus:ring-yellow-500 rounded"
              />
              <label htmlFor="allowContact" className="mt-1 text-xs sm:text-sm font-medium text-yellow-100 flex-1">
                Let Seller, Manufacturer, Representative, Facilitators, Aggregators contact me what I <span className="font-semibold">{selectedOption}</span>.
              </label>
            </div>

            <div className="flex justify-center">
              <button
                className="bg-blue-600 text-white px-6 py-2 sm:px-8 sm:py-3 rounded-full hover:bg-blue-700 transition-all duration-300 text-base sm:text-lg font-semibold shadow-lg hover:shadow-xl"
                onClick={() => alert('Submitted!')}
              >
                Submit
              </button>
            </div>
          </div>

          {/* Quick Action Buttons */}
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4 mt-2 bg-white/10 py-4 px-2 rounded-lg place-items-center">
            <button className="flex flex-col items-center justify-center px-4 py-3 text-white text-sm sm:text-base font-semibold bg-blue-600 rounded-xl hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-lg">
              💰 KharchoJeeto
            </button>
            <button className="flex flex-col items-center justify-center px-4 py-3 text-white text-sm sm:text-base font-semibold bg-blue-600 rounded-xl hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-lg">
              🥔 Aalu Dalo<br/>Sona Nikalo
            </button>
            <button className="flex flex-col items-center justify-center px-4 py-3 text-white text-sm sm:text-base font-semibold bg-blue-600 rounded-xl hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-lg">
              📢 Complaint Karo
            </button>
            {/* <button className="flex flex-col items-center justify-center px-4 py-3 text-blue-700 text-sm sm:text-base font-semibold bg-yellow-200 rounded-xl hover:bg-yellow-300 transition-all duration-300 shadow-md hover:shadow-lg">
              📅 Meri Dincharya
            </button> */}
            <button className="flex flex-col items-center justify-center px-4 py-3 text-white text-sm sm:text-base font-semibold bg-blue-600 rounded-xl hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-lg">
              🧠 Ask The Expert
            </button>
            <button className="flex flex-col items-center justify-center px-4 py-3 text-white text-sm sm:text-base font-semibold bg-blue-600 rounded-xl hover:bg-blue-700 transition-all duration-300 shadow-md hover:shadow-lg">
              🤖 Ask AI
            </button>
          </div>
        </div>
      </section>

      {/* Something New Section */}
      <section id="somethingnew" className="py-4 px-4 sm:px-6 md:px-8 bg-black">
        <h2 className="text-xl lg:text-2xl font-bold text-center mb-8 text-yellow-200">New Launches</h2>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 max-w-7xl mx-auto">
          {[
            {
              id: 1,
              title: "DairyFresh Milk 1L",
              description: "High-quality pasteurized milk · Available in all stores"
            },
            {
              id: 2,
              title: "Luxe Handwash 250ml",
              description: "Gentle on hands · Long-lasting fragrance · 20% Off"
            },
            {
              id: 3,
              title: "NutriBar Chocolate 50g",
              description: "Rich in protein · Gluten-free · Buy 1 Get 1 Free"
            }
          ].map((newlaunch) => (
            <div key={newlaunch.id} className="bg-gray-300 shadow-md hover:shadow-xl transition-all duration-300 rounded-2xl overflow-hidden">
              <img 
                src={`/api/downloads/thinktravel/deals/${newlaunch.id}.png`} 
                alt={"Image " + newlaunch.id} 
                className="w-full h-48 sm:h-52 object-cover"
                loading="lazy"
              />
              <div className="p-4 sm:p-5">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-800 line-clamp-2">{newlaunch.title}</h3>
                <p className="text-gray-600 mt-2 text-sm sm:text-base line-clamp-2">{newlaunch.description}</p>
                <button 
                  onClick={() => navigate(`/feetfirst/${newlaunch.id}`)}
                  className="mt-4 w-full sm:w-auto px-4 py-2 bg-pink-500 text-white rounded-full hover:bg-pink-600 text-sm transition-colors duration-300 font-medium"
                >
                  View New Launch
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Complaint Section */}
      <section id="complaint" className="w-full py-4 sm:py-16 px-4 sm:px-6 md:px-8 bg-black">
        <div className="mx-auto flex flex-col lg:flex-row gap-6">
          {/* Complaint List */}
          <div className="flex-1">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg sm:text-xl font-bold text-yellow-200">Complaints</h2>
              <button
                className="px-4 py-2 w-20 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                onClick={() => { setShowNewForm(!showNewForm); setSelectedComplaint(null); setSubmitMsg(""); }}
              >
                + New
              </button>
            </div>

            {showNewForm && (
              <div className="bg-gray-300 shadow-md rounded-xl p-6 mb-4">
                <h3 className="text-xl font-semibold text-gray-800 mb-4">New Complaint</h3>
                <div className="flex flex-col gap-3">
                  <input
                    type="text"
                    placeholder="Company Name *"
                    className="p-2 border border-gray-300 rounded-md"
                    value={newComplaint.company}
                    onChange={(e) => setNewComplaint({ ...newComplaint, company: e.target.value })}
                  />
                  <input
                    type="text"
                    placeholder="Product/Service Name *"
                    className="p-2 border border-gray-300 rounded-md"
                    value={newComplaint.product}
                    onChange={(e) => setNewComplaint({ ...newComplaint, product: e.target.value })}
                  />
                  <textarea
                    placeholder="Complaint Description *"
                    className="p-2 border border-gray-300 rounded-md"
                    rows={4}
                    value={newComplaint.description}
                    onChange={(e) => setNewComplaint({ ...newComplaint, description: e.target.value })}
                  ></textarea>
                  <button
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition"
                    onClick={handleNewSubmit}
                  >
                    Submit
                  </button>
                  {submitMsg && <p className="text-green-700 font-medium mt-2">{submitMsg}</p>}
                </div>
              </div>
            )}

            <div className="w-full grid grid-cols-1 sm:grid-cols-1 gap-4">
              {complaints.map((c) => (
                <div key={c.id} className="bg-gray-300 shadow-md rounded-lg p-4 hover:shadow-xl transition cursor-pointer"
                    onClick={() => handleViewMore(c)}>
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-gray-800">{c.company}</span>
                    <span className="text-gray-500 text-sm">{c.date}</span>
                  </div>
                  <p className="text-gray-600 text-sm mt-1">Complainant: {c.complainant}</p>
                  <p className="text-gray-600 text-sm mt-1">Product/Service: {c.product}</p>
                  <button
                    className="mt-2 px-3 py-1 bg-pink-500 text-white rounded-full text-sm hover:bg-pink-600 transition"
                    onClick={(e) => { e.stopPropagation(); handleViewMore(c); }}
                  >
                    View More
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Complaint Details / New Form */}
          <div className="flex-1">
            {selectedComplaint && (
              <div className="bg-white shadow-md rounded-xl p-6">
                <h3 className="text-xl font-semibold text-gray-800 mb-2">{selectedComplaint.company}</h3>
                <p className="text-gray-600 mb-1"><span className="font-medium">Complainant:</span> {selectedComplaint.complainant}</p>
                <p className="text-gray-600 mb-1"><span className="font-medium">Product/Service:</span> {selectedComplaint.product}</p>
                <p className="text-gray-600 mb-4"><span className="font-medium">Date:</span> {selectedComplaint.date}</p>
                <p className="text-gray-700 mb-4">{selectedComplaint.description}</p>
                <button
                  className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
                  onClick={handleReply}
                >
                  Reply
                </button>
              </div>
            )}
          </div>
        </div>
      </section>
      
      {/* Why Us Section */}
      <section id="whyus" className="py-6 px-4 bg-black">
        <h2 className="text-2xl sm:text-3xl font-bold text-center mb-8 text-yellow-200">Why Bolograhak?</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-6xl mx-auto text-center">
          {[
            {
              title: "Best Prices",
              emoji: "💰",
              desc: "We negotiate directly with partners to offer unbeatable prices.",
            },
            {
              title: "Verified Partners",
              emoji: "✅",
              desc: "Only trusted, high-quality resorts and hotels make the list.",
            },
            {
              title: "24/7 Support",
              emoji: "📞",
              desc: "Our team is always ready to assist you with your booking journey.",
            },
          ].map((feature, idx) => (
            <div key={idx} className="p-4 sm:p-6 bg-white/10 rounded-2xl backdrop-blur-sm border border-white/20">
              <div className="text-2xl lg:text-4xl mb-4 mx-auto">{feature.emoji}</div>
              <h4 className="text-lg sm:text-xl font-semibold mb-2 text-white">{feature.title}</h4>
              <p className="text-white/90 text-sm sm:text-base leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Business Profile Form */}
      <BusinessProfileForm />

      {/* Footer */}
      <footer className="bg-gradient-to-r from-green-800 to-green-900 text-yellow-200 px-4 py-6 sm:py-8">
        <div className="flex flex-col sm:flex-row justify-between items-center text-center sm:text-left space-y-4 sm:space-y-0">
          <p className="text-xs sm:text-sm text-yellow-200">&copy; 2025 Think5Whys. All rights reserved.</p>
          <div className="flex flex-wrap justify-center sm:justify-start space-x-4 sm:space-x-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-yellow-400 transition-colors duration-300">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-yellow-400 transition-colors duration-300">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-yellow-400 transition-colors duration-300">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-yellow-400 transition-colors duration-300">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default BoloGrahakHome;